import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'formik';
import last from 'lodash/last';
import Grid from '@material-ui/core/Grid';
import FormikAutocompleteSelect from '../../../../components/Fields/FormikAutocompleteSelect';
import { useTranslation } from '../../../../src/i18n';
import TitleWithInfo from '../../../../components/TitleWithInfo';
import AddAnotherField from '../../../../components/AddAnotherField';
import { TP } from '../../../../constants/consts';
import { isFocusedAddAnotherField } from '../../../../utils/editCommon';

const LangsEditFields = ({ values, languageField, langs, subtitlesField, classNames }) => {
  const { t } = useTranslation();

  return (
    <>
      <TitleWithInfo
        style={{ fontWeight: 'bold' }}
        titleSize="big"
        title={t(`${TP}.FN_LANG_AND_SUBTITILES`)}
        tooltip={t(`${TP}.FN_LANG_AND_SUBTITILES_TOOLTIP`)}
      />
      <Grid container spacing={6} className={classNames.addFields}>
        {[languageField, subtitlesField].map(langGroup => (
          <Grid item md={6} xs={12} sm={12} key={langGroup.name}>
            <FieldArray name={langGroup.name}>
              {arrayHelpers => {
                const parentName = langGroup.name;
                const langsGroup = values[langGroup.name] || [languageField.value];
                return langsGroup.map((subtitle, index) => {
                  const fieldName = `${parentName}.${index}`;
                  return (
                    <AddAnotherField
                      key={fieldName}
                      values={langsGroup}
                      removeFunc={() => arrayHelpers.remove(index)}
                      addFunc={() => arrayHelpers.push(null)}
                      isLast={index === langsGroup.length - 1}
                      addDisabled={!last(langsGroup)?.value}
                      addButtonPosition="bottom"
                    >
                      <Field
                        autoFocus={isFocusedAddAnotherField(index, langsGroup)}
                        instanceId={fieldName}
                        name={fieldName}
                        component={FormikAutocompleteSelect}
                        options={langs}
                        label={t(langGroup.label)}
                        isClearable
                        withFiltering
                        isCreatable
                      />
                    </AddAnotherField>
                  );
                });
              }}
            </FieldArray>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

LangsEditFields.propTypes = {
  values: PropTypes.object.isRequired,
  languageField: PropTypes.object.isRequired,
  subtitlesField: PropTypes.object.isRequired,
  langs: PropTypes.array.isRequired,
};

export default memo(LangsEditFields);
